import React, { useCallback, useState } from "react";
import image3 from "../assets/page2new.webp";
import image3mobile from "../assets/page2newmobile.webp";
import QuoteIcon from "../assets/QuoteIcon.svg";

import { Link } from "react-router-dom";

export default function Page2_1() {
  return (
    <div className="custom-container_new_page2">
      <div className="d-flex flex-column flex-lg-row align-items-center justify-content-center ">
        <div className="pt-4 pt-md-0 d-flex justify-content-center align-items-center page2newbgimgdiv">
          <div className="col-12 col-lg-7 w-100 newpage2phr">
            <img src={QuoteIcon} className="QuoteIcon"></img>
            <h1 className="pt-2 pb-3">Meet Our Expert</h1>
            <p className="col-12  pb-3">
              At the heart of Andromeda-Sim is Alfredo Celso, a seasoned Flight
              Simulation Engineer with a passion for advancing training
              technology. With years of hands-on experience in the aviation
              industry, Alfredo combines technical expertise with a deep
              understanding of simulator operations to help clients achieve peak
              performance.
            </p>

            <p className="col-12 ">
              He leads our sales strategy, manages client relationships, and
              ensures every project receives personalised attention — from the
              first consultation to ongoing support. Alfredo's commitment to
              excellence and problem-solving mindset makes him a trusted partner
              for training centres and airlines worldwide
            </p>

            <Link to="/contact-us">
              <button className="btn-home1new  mt-4 mb-0 mb-md-5">
                Contact Now
              </button>
            </Link>
          </div>
        </div>

        <div className="col-12 col-lg-5 position-relative image_divv">
          <div className="image-new-page2">
            {" "}
            <img
              src={image3}
              className="img-fluid d-none d-md-block    rounded-4"
              alt="Andromeda"
            />
          </div>
          <img
            src={image3mobile}
            className="img-fluid d-block d-md-none"
            alt="Andromeda"
          />
          <div className="lg_screen_name_div  d-none d-md-block">
            <p className="Alfredo_name">Alfredo Celso</p>

            <p className="Engineer_position">Flight Simulation Engineer & Lead Consultant</p>
          </div>

          <div className="position-absolute sm_screen_name_div translate-middle-x text-center  d-block d-md-none">
            <p className="Alfredo_name">Alfredo Celso</p>

            <p className="Engineer_position ">
              Flight Simulation Engineer & Lead Consultant
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
